import React, { CSSProperties } from 'react';
import './GameButton.css';

export interface GameButtonProps {
  disabled?: boolean;
  onClick: (() => void) | undefined;
  rootStyle?: CSSProperties;
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
}

export const GameButton = (props: GameButtonProps) => {
  const { children, disabled, onClick, rootStyle } = props;
  return (
    <div className={'game_button-root'}>
      <div
        className={`game_button-btn ${disabled ? 'game_button-disabled' : ''} game_button-btn_${
          props.variant ?? 'primary'
        }`}
        style={rootStyle}
        onClick={!disabled ? onClick : undefined}
      >
        {children}
      </div>
    </div>
  );
};
